module.exports = __webpack_public_path__ + "static/media/total-logo.f46a4157.png";